<template>
  <div class="layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {

  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue